// src/pages/sets-page/components/create-set-form/CreateSetForm.styles.js
import styled from 'styled-components';

export const CreateSetFormContainer = styled.div`
  align-items: start;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TagItem = styled.span`
  display: inline-flex;
  align-items: center;
  background: rgba(76, 175, 80, 0.2);
  border: 1px solid rgba(76, 175, 80, 0.5);
  border-radius: 20px;
  box-sizing: border-box;
  padding: 4px 12px;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 500;
  gap: 8px;
`;

export const TagRemoveButton = styled.button`
  background: none;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  padding: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;

export const ErrorMessage = styled.span`
  color: #ff6b6b;
  font-size: 12px;
  font-weight: 500;
  margin: 4px 0px;
  display: block;
`;
